import { useContext, useEffect, useMemo, useState } from 'react';
import { getZoomRecordingFile } from '../../clients/getZoomRecordingFile';
import { MediaElementContext } from '../../context/MediaElementContext';
import { ErrorTypes } from '../../types/ErrorTypes';
import { logMediaPlayerErrorMetric } from '../../utils/logMediaPlayerErrorMetric';
import { getNetworkErrorResult } from '../../utils/getNetworkErrorResult';
import { jsx as _jsx } from "react/jsx-runtime";
const ZOOM_DOWNLOAD_REGEX = /^https:\/\/zoom.us\/rec\/download\/.+/i;
export const withZoomAudioDownload = Component => {
  return props => {
    const {
      engagementId,
      externalAccountId,
      setErrorStatus
    } = useContext(MediaElementContext);
    const isAllowedSource = useMemo(() => props.recordingUrl && ZOOM_DOWNLOAD_REGEX.test(props.recordingUrl), [props.recordingUrl]);
    const [parsedUrl, setParsedUrl] = useState(isAllowedSource ? undefined : props.recordingUrl);
    useEffect(() => {
      let mounted = true;
      if (!isAllowedSource) {
        setParsedUrl(props.recordingUrl);
        return () => {};
      }
      setParsedUrl(undefined);
      if (engagementId && externalAccountId) {
        getZoomRecordingFile({
          engagementId: engagementId,
          externalAccountId: externalAccountId
        }).then(res => {
          if (!mounted) return;
          setParsedUrl(res);
        }).catch(error => {
          if (!mounted) return;
          const {
            errorType,
            networkStatus
          } = getNetworkErrorResult(error, true);
          setErrorStatus(errorType);
          logMediaPlayerErrorMetric({
            errorType,
            requestedRecordingUrlUpdate: false,
            source: props.source,
            status: networkStatus
          });
        });
      } else {
        setErrorStatus(ErrorTypes.ZOOM_FETCH_MISSING_REQUIREMENTS);
      }
      return () => {
        mounted = false;
      };
    }, [engagementId, externalAccountId, isAllowedSource, props.recordingUrl, props.source, setErrorStatus]);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      recordingUrl: parsedUrl
    }));
  };
};